var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"team__cover"},[_c('img',{attrs:{"src":_vm.img}}),_c('h3',[_vm._v(_vm._s(_vm.name))]),_c('p',[_c('i',{staticClass:"fa fa-user-tag"}),_vm._v(" "+_vm._s(_vm.role))])])}
var staticRenderFns = []

export { render, staticRenderFns }